import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider, useDispatch } from "react-redux";

import { renderRoutes, adminRoutes, authRoutes } from "./routes";
import store from "./redux/store";
import { userSignInSuccessAction } from "./redux/Actions/AuthAction";

const App = () => {

  return (
    <Provider store={store}>
      <HandleNavigation />
    </Provider>
  );
};

const HandleNavigation = () => {

  const dispatch = useDispatch()
  const [user, setUser] = useState();

  useEffect(() => {
    getDetails()
  }, [user])

  const getDetails = async () => {
    const utoken = localStorage.getItem('dummy')
    const udata = localStorage.getItem('dummyData')
    const data = JSON.parse(udata)
    dispatch(userSignInSuccessAction(data?.user));
    setUser(utoken)
  }

  return (
    <React.Fragment>
      <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
        {user ? renderRoutes(adminRoutes) : renderRoutes(authRoutes)}
      </BrowserRouter>
    </React.Fragment>
  )
}

export default App;

